module.exports = __webpack_public_path__ + "static/media/world-map.32a3c6d6.jpg";